import React, { Fragment } from 'react';
import { GridLayout } from 'components/form/layout';
import Title from 'components/Title';
import { PercentageFloatField, IntegerField } from 'components/form/field';

const MicroBNC = () => (
    <Fragment>
        <Title>Micro BNC</Title>
        <GridLayout className="double condensed full-width">
            <IntegerField
                name="summary.incomeTax.microBNCAbatement.min"
                title="Seuil (€)"
            />
            <PercentageFloatField
                name="summary.incomeTax.microBNCAbatement.rate"
                title="Abattement (%)"
            />
        </GridLayout>
    </Fragment>
);

export default MicroBNC;
